import React from 'react';
import type { WhatsAppMessage } from '../types/message';
import { WhatsAppMessageCard } from './message/WhatsAppMessageCard';

interface MessageBubbleProps {
  message: WhatsAppMessage;
}

const MessageBubble: React.FC<MessageBubbleProps> = ({ message }) => {
  return <WhatsAppMessageCard message={message} />;
};

export default MessageBubble;
